// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","container":"Footer_container__iICw7","socialIcons":"Footer_socialIcons__kXiic","copyRight":"Footer_copyRight__Hwf14"};